import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleAlert, ListChecks } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Spinner } from '@/components/ui/spinner';
import DesignVerificationSetting from './DesignVerificationSetting';
import SectionCard from './SectionCard';
import type { TenantSettingsResponse } from '@services/settings.service';

interface FeatureSettingsCardProps {
  settings: TenantSettingsResponse | null;
  loading: boolean;
  error: string | null;
  canManage: boolean;
  onToggleDesignVerification: (next: boolean) => void;
}

const FeatureSettingsCard: React.FC<FeatureSettingsCardProps> = ({
  settings,
  loading,
  error,
  canManage,
  onToggleDesignVerification,
}) => {
  const { t } = useTranslation();

  return (
    <SectionCard icon={ListChecks} title={t('settings.featureSettings')}>
      {loading && (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      )}

      {error && (
        <Alert variant="destructive" className="mb-4">
          <CircleAlert className="h-4 w-4" />
          <AlertDescription className="revy-cjk leading-[1.6]">{error}</AlertDescription>
        </Alert>
      )}

      {settings && !loading && (
        <DesignVerificationSetting
          enabled={settings.settings.features.design_verification}
          disabled={!canManage || loading}
          canManage={canManage}
          onToggle={onToggleDesignVerification}
        />
      )}
    </SectionCard>
  );
};

export default FeatureSettingsCard;
